module.exports = __webpack_public_path__ + "static/media/need_assistance.0e8e1d7e.svg";